import { NeobrutalButton } from '@/components/marketing/v2/NeobrutalButton';

export default function ComparePromoBandV2() {
  return (
    <section className="bg-lime-500 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-center md:justify-between">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-3 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-700">
              <span className="h-px w-9 bg-charcoal-800" />
              Comparaison des plans
            </div>
            <h3 className="mt-5 font-marketing-display text-[clamp(30px,3.4vw,48px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-950">
              Les 8 modules sont dans{' '}
              <span className="bg-charcoal-800 px-2 text-lime-400">chaque plan.</span>
            </h3>
            <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-800/90">
              Tu choisis seulement le volume : nombre de boutiques, d'employés et d'appareils. Pas
              de fonctionnalité cachée derrière un paywall.
            </p>
          </div>
          <div className="flex-shrink-0">
            <NeobrutalButton as="link" to="/tarifs" variant="dark" size="lg">
              Voir les tarifs
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path d="M5 12h14" />
                <path d="M13 6l6 6-6 6" />
              </svg>
            </NeobrutalButton>
          </div>
        </div>
      </div>
    </section>
  );
}
